const TeleHealthLanding = () => {
  
    <div></div>
};

export default TeleHealthLanding;
